<label class="mm-switch-toggle"
       [class.mm-switch-toggle-disabled]="disabled">
    <input type="checkbox"
           [(ngModel)]="checked"
           [ngModelOptions]="{standalone: true}"
           (ngModelChange)="onModelChange($event)"
           [disabled]="disabled">
    <span class="mm-switch-toggle-slider"></span>
</label>
